// Vendors
import { useEffect, useRef, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Constants
import { KYC_BIZUM_WS_TIME_PROPS } from './constants/kyc-bizum.hook.constants';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useKycContextConsumerHook } from 'containers/kyc/contexts/kyc.context';
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
// Event Handlers
import { KycBizumHandlers } from '../handlers/kyc-bizum.handlers';
// Hooks
import { useAppGetStateHook } from 'hooks/get-state.hook';
// Types
import { KycBizumHookType } from './types/kyc-bizum.hook.type';
// Utilities
import { getInitialKYCBizumTimerFromStorage } from '../utils/kyc-bizum.utils';

const useKycBizumHook = (): KycBizumHookType => {
  const [timer, setTimer] = useState<number>(getInitialKYCBizumTimerFromStorage());

  const { setCurrentState, setOnHeaderBackClick } = useAppContextConsumerHook(),
    { setMainButtonConfiguration } = useLayoutContextConsumerHook(),
    { handleUpdateKycHeaderBackClick } = useKycContextConsumerHook();

  const { showBoundary: setError } = useErrorBoundary();

  const {
      handleOnErrorKycBizumWsMessage: onError,
      handleOnReceiveKycBizumWsMessage: onSuccess,
      handleSetupEnvironmentForKYCBizumEvent,
    } = KycBizumHandlers({
      setCurrentState,
      setError,
      setMainButtonConfiguration,
      setOnHeaderBackClick,
      handleUpdateKycHeaderBackClick,
      setTimer,
    }),
    { handleGetOnboardingStateEvent } = useAppGetStateHook({
      ...KYC_BIZUM_WS_TIME_PROPS,
      onError,
      onSuccess,
    });

  useEffect(() => {
    const cleanup = handleSetupEnvironmentForKYCBizumEvent();
    handleGetOnboardingStateEvent();

    return cleanup;
  }, []);

  return { timer };
};

export { useKycBizumHook };
